module.exports = __webpack_public_path__ + "img/pointer.2c002e98.svg";